import type { Color } from '../types/game'

export function formatPlayerFacingError(message: string, selfColor: Color | null | undefined): string {
  if (!selfColor) {
    return message
  }

  let formatted = message.split(`{${selfColor}}`).join('You')

  if (formatted.startsWith('You does not')) {
    formatted = formatted.replace('You does not', 'You do not')
  }

  if (formatted.startsWith('You has ')) {
    formatted = formatted.replace('You has ', 'You have ')
  }

  if (formatted.includes(' not their turn')) {
    formatted = formatted.replace(' not their turn', ' not your turn')
  }

  if (formatted.includes('to themselves')) {
    formatted = formatted.replace('to themselves', 'to yourself')
  }

  return formatted
}
